import React from 'react';
import { ArrowDown } from 'lucide-react';
import DataWellSVG from './DataWellSVG';  // Added DataWellSVG import

const HeroSection = ({ parallaxOffset }) => {
    return (
        <header className="relative h-screen flex items-center justify-center overflow-hidden">
            <div
                className="absolute inset-0 bg-gradient-to-b from-blue-900/70 to-slate-900/90 z-10"
                style={{ transform: `translateY(${parallaxOffset}px)` }}
            ></div>
            <div className="absolute inset-0 w-full h-full">
                <DataWellSVG />
            </div>
            <div className="relative z-20 text-center px-4 space-y-8">
                <h1 className="text-8xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                    DIO+ Automation 
                </h1>
                <p className="text-4xl mb-8">Work smarter, not harder - automation that works for you</p>

                <button
                    onClick={() => {
                        const nextSection = document.querySelector('section');
                        if (nextSection) {
                            nextSection.scrollIntoView({ behavior: 'smooth' });
                        }
                    }}
                    className="cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-slate-900 rounded-full p-2"
                    aria-label="Scroll to next section"
                >
                    <ArrowDown className="w-10 h-10 mx-auto text-blue-400 hover:text-blue-300 transition-colors animate-bounce" />
                </button>
            </div>
        </header>
    );
};

export default HeroSection;